export default "__VITE_ASSET__BNgUJ_LW__"